import React, {useState, useEffect} from 'react';
import './style.css';
import {useDispatch, useSelector} from "react-redux";


import {Button, Form, FormField, Dropdown, Search, Loader, Dimmer, Modal} from 'semantic-ui-react'
import { ReactComponent as ArrowIcon } from "../../icons/arrow-dropdown-icon.svg";
import { ReactComponent as CloseIconAsia} from "../../icons/close-red-icon.svg";
import { ReactComponent as CloseIconGras } from "../../icons/close-green-icon.svg";
import {createMeeting, viewMeetingPlaces, viewMeetingPlacesExp} from "../../views/AsiaMeet/actions";
import translations from "../LanguageModal/translations";
import {getLanguage} from "../LanguageModal/reducer";
import {toastr} from "react-redux-toastr";
import DatePicker from "react-datepicker";
import ru from "date-fns/locale/ru";
import ModalDateSelection from '../../components/ModalDateSelection/ModalDateSelection';
import {Value} from "sass";
import {getTypeExhibition} from "../../views/Home/reducer";
import {getFetchingPlaces, getMeetingPlaces, getMeetingPlacesExponents} from "../../views/AsiaMeet/reducer";
import {reverse} from "lodash/seq";


export default function FormMeeting(props) {
    const { company, token, handleClose, persons, stand, mixpanel} = props;
    let date = new Date();

    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));
    const meetingPlaces = useSelector((state) => getMeetingPlaces(state.meets));
    const isFetchingPlaces = useSelector((state) => getFetchingPlaces(state.meets));
    const dataExhibition = {
        asia: {
            closeIcon: (props) => <CloseIconAsia  {...props} />,
        },
        gras: {
            closeIcon: (props) => <CloseIconGras  {...props} />,
        }
    }


    date = date.toISOString().split('T')[0];
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({});
    // console.log(formData)
    const [statusButton, setStatusButton] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isCorrectTime, setIsCorrectTime] = useState(false);
    const [isDateModalOpen, setIsDateModalOpen] = useState(false);
    const [timeChangeModalOpen, setTimeChangeModalOpen] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        validate()
    }, [formData]);


    const uniqueMeetingPlaces = useSelector((state) => getMeetingPlacesExponents(state.meets))


    const personsMeet = [...new Map(
        meetingPlaces
            .filter(place => place.respondent_exponent === formData.exponent && place.respondent_user != 0)
            .map(place => [place.respondent_user, place])
    ).values()].map((person) => {
        return {
            key: person.id,
            value: person.respondent_user,
            text: languageString === "ru"
                ? person.respondent_user_name
                : person.respondent_user_name_en
        };
    });

    const jobTitles = Object.entries(
        meetingPlaces.reduce((acc, place) => {
            const jobTitles = place.respondent_job_titles;
            const jobTitlesEn = place.respondent_job_titles_en;

            for (const key in jobTitlesEn) {
                if (jobTitles[key] && jobTitlesEn[key]) {
                    acc[jobTitlesEn[key]] = jobTitles[key]; // Сохраняем английское значение как ключ, русское — как текст
                }
            }
            return acc;
        }, {})
    ).map(([key, text], index) => ({
        key,       // Английское значение (например, "Agronomist")
        text,      // Русское значение (например, "Агроном")
        value: index // Индекс для уникальности
    }));

    const jobTitlesEn = Object.entries(
        meetingPlaces.reduce((acc, place) => {
            const jobTitlesEn = place.respondent_job_titles_en;

            for (const key in jobTitlesEn) {
                if (jobTitlesEn[key]) {
                    acc[jobTitlesEn[key]] = jobTitlesEn[key]; // Сохраняем английское значение как ключ и текст
                }
            }
            return acc;
        }, {})
    ).map(([key, text], index) => ({
        key,       // Английское значение (например, "Agronomist")
        text,      // Английское значение (например, "Agronomist")
        value: index // Индекс для уникальности
    }));

    //console.log(jobTitles, jobTitlesEn);

    useEffect(() => {
        const params = {
            event: typeExhibition === 'gras' ? 'GRAS 2025' : 'ASIAEXPO 2025',
        }

        if (formData.person) {
            if (formData.person.id) {
                params['respondent_user'] = formData.person.id
            } else {
                params['respondent_user'] = formData.person;
            }
        }

        if (formData.exponent) {
            params['respondent_exponent'] = formData.exponent
        }

        dispatch(viewMeetingPlaces(token, languageString, params))
        dispatch(viewMeetingPlacesExp(token, languageString, params));

    }, [formData.person, formData.exponent]);

    const convertToMinutes = (time) => {
        const [hours, minutes] = time.split(':').map(Number);
        return hours * 60 + minutes;
    };

    const meetingDays = [...new Set(meetingPlaces.filter(p => p.respondent_exponent === formData.company).map(x => x.on_date))]
    const meetingSlots = meetingPlaces
        .filter(p => p.respondent_exponent === formData.company)
        .filter(p => {
            const isAnyEmployee = formData.person === '0';
            return isAnyEmployee
                ? p.respondent_user === '0'
                : p.respondent_user === String(formData.person);
        })
        .filter(p => p.on_date === formData.date)
        .sort((a, b) => a.on_time.localeCompare(b.on_time));


    // console.log(meetingSlots, meetingPlaces
    //     .filter(p => formData.person === '0'
    //         ? p.respondent_user === '0'
    //         : p.respondent_user === formData?.person
    //     )
    //     .filter(p => p.on_date === formData.date)
    // )

    const handleChangePerson = (e, { value }) => {
        setFormData({
            ...formData,
            person: value,
            date: '',
            time: '',
            place: '',
            description: '',

        });
    };

    const handleChangeJobTitle = (e, { value }) => {
        const selectedJobTitle = jobTitles.find(job => job.value === value); // Находим выбранный объект
        setFormData({
            ...formData,
            job_title: selectedJobTitle, // Сохраняем весь объект
            date: '', // Сбрасываем зависимые поля
            time: '',
            place: '',
            description: ''
        });
    };

    const handleChangePlace = (e, {value}) => {
        setFormData({
            ...formData,
            place: value,
        });
    }


    const handleChangeTime = (e) => {
        const {value} = e.target;
        const minTime = '9:00'
        const maxTime = '18:00'

        const userTimeInMinutes = convertToMinutes(value);
        const minTimeInMinutes = convertToMinutes(minTime);
        const maxTimeInMinutes = convertToMinutes(maxTime);

        if (userTimeInMinutes >= minTimeInMinutes && userTimeInMinutes <= maxTimeInMinutes) {
            setFormData({
                ...formData,
                time: value,
            });
            setIsCorrectTime(true);
        } else {
            setIsCorrectTime(false);
        }

    }

    const handleChangeDate = (date) => {
        // console.log(date)
        if (formData.date !== date) {
            setFormData({
                ...formData,
                date: date.split('.').reverse().join('-'),
                time: '',
                place: '',
                placeInput: '',
            });
        } else {
            setFormData({
                ...formData,
                date: date.split('.').reverse().join('-'),
            });
        }
    }

    const handleChangeText = (e) => {
        const {value, name} = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    }


    const validate = () => {
        if ( formData.time && isCorrectTime && formData.date && formData.description) {
            setStatusButton(true);
        } else {
            setStatusButton(false)
        }

    }

    // console.log(formData, 'form')

    const handleSubmit = () => {
        setIsLoading(true);
        dispatch(createMeeting(
            token,
            languageString,
            (typeExhibition.toUpperCase() === 'GRAS' ? 'GRAS 2025' : 'ASIAEXPO 2025'),
            formData.company,
            (formData.person === '0' ? 0 : formData.person),
            (formData.job_title?.key || ''),
            (formData.place === 0 ? formData.placeInput : formData.place),
            formData.date,
            formData.time,
            formData.description,
            true
        ))
            .then(() => {
                toastr.success(t('successMeet'));
                setIsLoading(false);
                handleClose();
            })
            .catch(() => {
                setIsLoading(false);
                handleClose();
            });

        setFormData({
            company: '',
            person: '',
            time: '',
            place: '',
            date: '',
            description: '',
            job_title: '',
        });

        if (mixpanel) {
            mixpanel.track('Action. Create meet');
        }
    };

    useEffect(() => {
        if (company) {
            setFormData({
                ...formData,
                company: company.id,
                person: 0,
            })
        }
    }, []);

    const handleChangeCompany = (e, {value}) => setFormData({
        ...formData,
        company: value,
        person: 0,
        date: '',
        time: '',
        place: '',
        description: '',
        job_title: {
            value: '',
            key: '',
            index: ''
        },
    })

    // console.log(formData, meetingSlots, meetingDays);

    const CloseIcon = (props) => dataExhibition[typeExhibition].closeIcon(props);

    return (
        <div className="meeting-view">
            <CloseIcon className="meeting-close" onClick={handleClose} />
            <h2 className={"meeting-title"}>{t('appointMeet')}</h2>
            {/*{typeExhibition !== 'gras' ? ''*/}
            {/*    // <Form className="meeting-form">*/}
            {/*    //     <FormField className="meeting-formfield">*/}
            {/*    //         <label className="meeting-label">{t('personMeet')}</label>*/}
            {/*    //         <Dropdown*/}
            {/*    //             className="meeting-dropdown"*/}
            {/*    //             fluid*/}
            {/*    //             search*/}
            {/*    //             selection*/}
            {/*    //             options={[{text: t('anyEmployee'), value: 0}, ...persons]}*/}
            {/*    //             placeholder={t('placeholderFioText')}*/}
            {/*    //             icon={<ArrowIcon />}*/}
            {/*    //             name='person'*/}
            {/*    //             value={formData.person}*/}
            {/*    //             onChange={handleChangePerson}*/}
            {/*    //         />*/}
            {/*    //     </FormField>*/}
            {/*    //     <FormField className="meeting-formfield">*/}
            {/*    //         <label className="meeting-label">{t('dateMeet')}</label>*/}
            {/*    //         <input className='meeting-text' onClick={() => setIsDateModalOpen(true)} value={formData.date} placeholder={t("dateMeeting")}/>*/}
            {/*    //         <ModalDateSelection*/}
            {/*    //             open={isDateModalOpen}*/}
            {/*    //             handleClose={() => setIsDateModalOpen(false)}*/}
            {/*    //             handleOpen={() => setIsDateModalOpen(true)}*/}
            {/*    //             selectedDate={formData.date}*/}
            {/*    //             callback={(date) => handleChangeDate(date)}*/}
            {/*    //             setMinDate={new Date(2024, 9, 23)}*/}
            {/*    //             setMaxDate={new Date(2024, 9, 25)}*/}
            {/*    //             header={t('dateMeet')}*/}
            {/*    //         />*/}
            {/*    //     </FormField>*/}
            {/*    //     <FormField className="meeting-formfield">*/}
            {/*    //         <label className="meeting-label">{t('timeMeet')}</label>*/}
            {/*    //         <input className="meeting-text" type="time" onChange={handleChangeTime} value={formData.time} />*/}
            {/*    //         {!isCorrectTime && <span  className='edit-error'>{t('correctMeetTime')}</span>}*/}
            {/*    //     </FormField>*/}
            {/*    //     <FormField className="meeting-formfield" >*/}
            {/*    //         <label className="meeting-label">{t('placeMeet')}</label>*/}
            {/*    //         <Dropdown*/}
            {/*    //             className="meeting-dropdown"*/}
            {/*    //             fluid*/}
            {/*    //             search*/}
            {/*    //             selection*/}
            {/*    //             placeholder={t("placeholderPlaceText")}*/}
            {/*    //             icon={<ArrowIcon />}*/}
            {/*    //             onChange={handleChangePlace}*/}
            {/*    //             options={[*/}
            {/*    //                 {text:  t('standMeet')+ ' ' + stand, value: t('standMeet')+ ' ' + stand},*/}
            {/*    //                 {text: t('otherMeet'), value: 0},*/}
            {/*    //             ]}*/}
            {/*    //             value={formData.place}*/}
            {/*    //         />*/}
            {/*    //         {formData.place === 0 && <input style={{marginTop: '10px'}} maxLength={30} className='meeting-text' onChange={handleChangeText} placeholder={t("placeholderPlaceText")} name='placeInput' value={formData.placeInput}></input>}*/}
            {/*    //     </FormField>*/}
            {/*    //     <FormField className="meeting-formfield" >*/}
            {/*    //         <label className="meeting-label">{t('descriptionMeet')}</label>*/}
            {/*    //         <textarea className="meeting-text" maxLength={79} name='description' placeholder={t("placeholderDescriptionText")} onChange={handleChangeText} value={formData.description}></textarea>*/}
            {/*    //     </FormField>*/}
            {/*    //     <Button*/}
            {/*    //         className="meeting-btn"*/}
            {/*    //         type="submit"*/}
            {/*    //         content={t("btnMeet")}*/}
            {/*    //         disabled={!statusButton}*/}
            {/*    //         onClick={() => handleSubmit()}*/}
            {/*    //     />*/}
            {/*    // </Form>*/}
            {/*    :*/}
                <Form className="meeting-form">
                    <FormField className="meeting-formfield">
                        <label className="meeting-label">{t('exponentMeet')}</label>
                        <Dropdown
                            className="meeting-dropdown"
                            fluid
                            search
                            selection
                            disabled={company}
                            options={uniqueMeetingPlaces}
                            placeholder={t('placeholderExponentText')}
                            icon={<ArrowIcon />}
                            name='person'
                            value={!company ? formData?.exponent : uniqueMeetingPlaces.find(p => p?.value === company?.id)?.value}
                            onChange={handleChangeCompany}
                        />
                    </FormField>
                    {/*<FormField className="meeting-formfield">*/}
                    {/*    <label className="meeting-label">{t('personMeet')}</label>*/}
                    {/*    <Dropdown*/}
                    {/*        className="meeting-dropdown"*/}
                    {/*        fluid*/}
                    {/*        search*/}
                    {/*        selection*/}
                    {/*        options={[{text: t('anyEmployee'), value: 0}, ...personsMeet]}*/}
                    {/*        placeholder={t('placeholderFioText')}*/}
                    {/*        icon={<ArrowIcon />}*/}
                    {/*        name='person'*/}
                    {/*        value={formData.person}*/}
                    {/*        onChange={handleChangePerson}*/}
                    {/*    />*/}
                    {/*</FormField>*/}
                    <FormField className="meeting-formfield">
                        <label className="meeting-label">{t('placePost')}</label>
                        <Dropdown
                            className="meeting-dropdown"
                            fluid
                            search
                            selection
                            options={languageString === 'ru' ? [...jobTitles] : [...jobTitlesEn]}
                            placeholder={t('placeholderPostText')}
                            icon={<ArrowIcon />}
                            name='job_title'
                            value={formData.job_title?.value}
                            onChange={handleChangeJobTitle}
                        />
                    </FormField>
                    <FormField className="meeting-formfield">
                        <label className="meeting-label">{t('dateMeet')}</label>
                        {/*<input className='meeting-text' onClick={() => setIsDateModalOpen(true)} value={formData.date} placeholder={t("dateMeeting")}/>*/}
                        <Dropdown
                            className="meeting-dropdown"
                            fluid
                            // search
                            selection
                            options={meetingDays.map(day => ({
                                text: day.split('-').reverse().join(' ').replace('05', languageString === 'ru' ? 'мая' : 'May'),
                                value: day
                            }))}
                            placeholder={t('dateMeeting')}
                            icon={<ArrowIcon />}
                            name='date'
                            value={formData.date}
                            onChange={(e, { value }) => handleChangeDate(value)}
                        />
                    </FormField>
                    <FormField className="meeting-formfield">
                        <label className="meeting-label">{t('timeMeet')}</label>
                        {/*<button className="meeting-dropdown"> </button>*/}
                        <Button
                            className={`meeting-time-button ${formData.time ? 'time' : ''}`}
                            onClick={() => setTimeChangeModalOpen(true)}
                            // disabled={formData.time}
                            // style={? {color: 'initial !important'} : {}}
                            content={!formData.time ? t("placeholderTimeText") : formData.time}
                        />

                        <Modal
                            className='meeting-set-time-popup'
                            open={timeChangeModalOpen}
                            centered
                            // style={{margin: 'auto!important'}}
                            onClose={() => setTimeChangeModalOpen(false)}
                        >
                            <Modal.Content className="meeting-set-time-popup-content">
                                <Dimmer active={isFetchingPlaces} inverted>
                                    <Loader active={isFetchingPlaces}>{t("createMeet")}...</Loader>
                                </Dimmer>
                                <CloseIcon className="meeting-close"
                                           onClick={() => setTimeChangeModalOpen(false)}
                                           style={{top:'21px', right:'21px'}}
                                />
                                <h2 className='meeting-title'>{t('timeMeet')}</h2>

                                <div className='meeting-set-time-container'>
                                    {meetingSlots.map((place, index) => (
                                        <Button
                                            // style={meetingSlots.length > 3 ? {maxWidth:'80px'} : {}}
                                            disabled={place.meeting_status !== 'planned'}
                                            content={place.on_time}
                                            className='meeting-time-select-button'
                                            onClick={() => {setFormData({
                                                    ...formData,
                                                    time: place.on_time,
                                                    place: place.place_code
                                                });
                                                setIsCorrectTime(true);
                                                setTimeChangeModalOpen(false);
                                            }}
                                        />
                                    ))}
                                </div>
                            </Modal.Content>
                        </Modal>
                        {/*{!isCorrectTime && <span  className='edit-error'>{t('correctMeetTime')}</span>}*/}
                    </FormField>
                    {/*<FormField className="meeting-formfield" >*/}
                    {/*    <label className="meeting-label">{t('placeMeet')}</label>*/}
                    {/*    /!*<Dropdown*!/*/}
                    {/*    /!*    className="meeting-dropdown"*!/*/}
                    {/*    /!*    fluid*!/*/}
                    {/*    /!*    search*!/*/}
                    {/*    /!*    selection*!/*/}
                    {/*    /!*    placeholder={t("placeholderPlaceText")}*!/*/}
                    {/*    /!*    icon={<ArrowIcon />}*!/*/}
                    {/*    /!*    // onChange={handleChangePlace}*!/*/}
                    {/*    /!*    // options={[*!/*/}
                    {/*    /!*    //     {text:  t('standMeet')+ ' ' + stand, value: t('standMeet')+ ' ' + stand},*!/*/}
                    {/*    /!*    //     {text: t('otherMeet'), value: 0},*!/*/}
                    {/*    /!*    // ]}*!/*/}
                    {/*    /!*    value={formData.place}*!/*/}
                    {/*    /!*//*/}
                    {/*    <Button*/}
                    {/*        className={`meeting-time-button ${formData.place ? 'time' : ''}`}*/}
                    {/*        // onClick={() => setTimeChangeModalOpen(true)}*/}
                    {/*        disabled={formData.place}*/}
                    {/*        // style={? {color: 'initial !important'} : {}}*/}
                    {/*        content={!formData.place ? t("placeholderPlaceText") : formData.place}*/}
                    {/*    />*/}
                    {/*    {formData.place === 0 && <input style={{marginTop: '10px'}} maxLength={30} className='meeting-text' onChange={handleChangeText} placeholder={t("placeholderPlaceText")} name='placeInput' value={formData.placeInput}></input>}*/}
                    {/*</FormField>*/}
                    <FormField className="meeting-formfield" >
                        <label className="meeting-label">{t('descriptionMeet')}</label>
                        <textarea className="meeting-text" maxLength={79} name='description' placeholder={t("placeholderDescriptionText")} onChange={handleChangeText} value={formData.description}></textarea>
                    </FormField>
                    <Button
                        className={`meeting-btn ${typeExhibition}`}
                        type="submit"
                        content={t("btnMeet")}
                        disabled={!statusButton}
                        onClick={() => handleSubmit()}
                    />
                </Form>
            <Dimmer active={isLoading} inverted>
                <Loader active={isLoading}>{t("createMeet")}...</Loader>
            </Dimmer>
        </div>
    );
}

